import AirDatepicker from "air-datepicker";
import localeEn from "air-datepicker/locale/en";
// import "air-datepicker/air-datepicker.css";

export default () => {
  const form = document.querySelector(".snow-monkey-form");
  if (!form) {
    return;
  }
  formInit(form);

  const url = new URL(window.location.href);
  const urlParams = url.searchParams;
  const jobName = urlParams.get("job-name");
  if (jobName && jobName !== null) {
    const jobField = form.querySelector('[name="job"]');
    jobField.value = decodeURI(jobName);
  }

  // Snow Monkey formsのバリデーション処理後対策
  form.addEventListener("smf.invalid", (event) => {
    formInit(form);
  });
};

const formInit = (form) => {
  /**
   * ご連絡希望時間の切替
   */
  const contactRadios = form.querySelectorAll(
    'input[type="radio"][name="contact"]'
  );
  const desiredTime = form.querySelector(".desired-time");
  contactRadios.forEach((contactRadio) => {
    contactRadio.addEventListener("change", (event) => {
      if (event.target.value === "お電話") {
        desiredTime.style.display = "block";
        desiredTime.querySelector('input[name="desired-time"]').required = true;
      } else {
        desiredTime.style.display = "none";
        desiredTime.querySelector(
          'input[name="desired-time"]'
        ).required = false;
        desiredTime.querySelector('input[name="desired-time"]').value = null;
      }
    });
  });

  /**
   * 日付入力 AirDatepicker
   */
  const date = new Date();
  const inputDate = form.querySelector('input[name="date"]');
  new AirDatepicker(inputDate, {
    locale: localeEn,
    minDate: date.setDate(date.getDate() + 1),
    dateFormat: "yyyy/MM/dd",
    navTitles: {
      days: "<strong>yyyy</strong>/<i>MM</i>",
      months: "月を選択 <i>yyyy</i>",
      years: "yyyy1 - yyyy2",
    },
  });
};
